export default "__VITE_ASSET__BibZpr6v__"